import {PaginationItemSelect} from "@/theme/ui";

export const ProductsSelect = ({...rest}) => {

    const transform = (product) =>({
        label: product.name,
        value: product.id,
        price: +product.current_price,
        sku: product.sku,
        image: product.image,
    })

    return(
        <PaginationItemSelect
            placeholder={'Select product'}
            requestSearchName={'name'}
            routeName={'products.paginate'}
            requestDataName={'products'}
            transform={transform}
            {...rest}
        />
    )
}